import React from 'react';
import { Link } from 'react-router-dom';
import Address from '../Formatting/Address';
import { getEntityLink, useNewWindow } from '../../Services/helpers';
import recents from './RecentsClass';

const Result = ({children, to, close, model, id, external}) => {
    const handleClick = () => {
        if (model && id) {
            recents.add(model, id);
        }
        close();
    };

    if (external) {
        return <ExternalResult to={to} onClick={handleClick}>
            {children}
        </ExternalResult>;
    }

    return <Link to={to} onClick={handleClick} className="cursor-pointer hover:bg-slate-50 dark:hover:bg-black hover:ring ring-gray-200 dark:hover:ring-gray-700 rounded-lg p-2">
        {children}
    </Link>;
};

const ExternalResult = ({children, to, onClick}) => {
    const newWindow = useNewWindow();

    return <div onClick={() => {
        onClick();
        newWindow(to);
    }} className="cursor-pointer hover:bg-slate-50 dark:hover:bg-black hover:ring ring-gray-200 dark:hover:ring-gray-700 rounded-lg p-2">
        {children}
    </div>;
};

const CustomerResult = ({customer, close}) => {
    return <Result to={getEntityLink('Customers/Customer', customer.id)} close={close} model="Customers/Customer" id={customer.id}>
        <Address address={customer.address} limit={3} empty="[No address]" /><br />
        <div className="text-sm text-muted">{customer.name}</div>
    </Result>;
};

const RoundResult = ({round, close}) => {
    return <Result to={getEntityLink('Rounds/Round', round.id)} close={close} model="Rounds/Round" id={round.id}>
        {round.name}
    </Result>;
};

const QuoteResult = ({quote, close}) => {
    return <Result to={getEntityLink('Quotes/Quote', quote.id)} close={close} model="Quotes/Quote" id={quote.id}>
        <Address address={quote.address} limit={3} empty="[No address]" /><br />
        <div className="text-sm text-muted">{quote.name}</div>
    </Result>;
};

const PageResult = ({page, close}) => {
    return <Result to={page.to} close={close} model="App/Page" id={page.to} external={page.external}>
        <div className="font-medium">{page.title}</div>
    </Result>;
};

export {
    CustomerResult,
    RoundResult,
    QuoteResult,
    PageResult,
};
